<div class="div-panel">
    <app-error-update-form [initialData]="error$ | async" [errorIsArchived]="errorIsArchived$ | async"
        (updatedError)="updateError($event)" (archiveError)="archiveError()" (unarchiveError)="unarchiveError()"
        (sendEmail)="sendEmail()" (cancel)="goBack()">
    </app-error-update-form>
</div>